module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-0735.67c1afb3.jpg";